// lib/studioModelFamilies.ts
export type StudioModelFamily = {
  name: string;
  versions: ReadonlyArray<{ id: string; label: string }>;
  // Usage of a version the user cannot select still preselects the family's best selectable version.
  hiddenUsageSelectsFamily?: boolean;
};

// Display grouping only: each version stays its own registry model id. The first visible version is the one the family lands on.
export const STUDIO_MODEL_FAMILIES: ReadonlyArray<StudioModelFamily> = [
  {
    name: 'Nano Banana',
    versions: [
      { id: 'nano-banana-2', label: '2' },
      { id: 'nano-banana-2.1', label: '2.1' },
      { id: 'nano-banana-pro', label: 'Pro' },
      { id: 'nano-banana', label: '1' },
    ],
  },
  {
    name: 'MAI',
    hiddenUsageSelectsFamily: true,
    versions: [
      { id: 'mai-2.6', label: '2.6' },
      { id: 'mai-2.6-flash', label: '2.6 Flash' },
      { id: 'mai-2.5-pro', label: '2.5 Pro' },
      { id: 'mai-2.5-flash', label: '2.5 Flash' },
    ],
  },
];

export function studioModelFamilyOf(modelId: string | null | undefined): StudioModelFamily | undefined {
  return STUDIO_MODEL_FAMILIES.find(family => family.versions.some(version => version.id === modelId));
}

export function studioModelFamilyNamed(name: string): StudioModelFamily | undefined {
  return STUDIO_MODEL_FAMILIES.find(family => family.name === name);
}

export function visibleFamilyVersions(family: StudioModelFamily, visibleModelIds: readonly string[]) {
  return family.versions.filter(version => visibleModelIds.includes(version.id));
}

export function resolveFamilyVersion(family: StudioModelFamily, currentModelId: string | null | undefined, visibleModelIds: readonly string[]): string | undefined {
  const versions = visibleFamilyVersions(family, visibleModelIds);
  return versions.find(version => version.id === currentModelId)?.id ?? versions[0]?.id;
}
